//GeneratorFlag:[NoChange]
import routes from './routes'
import services from './services'
import resources from './resources'
import toolbar from './toolbar'

const asset = {
	name: 'asset',
	foldreName: 'asset',
	routes,
	services,
	resources,
	toolbar
}

export default asset
export { routes, services, resources, toolbar }